module.exports = __webpack_public_path__ + "static/img/kxqy.8259ec4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/kxqy.jpeg
// module id = msOQ
// module chunks = 0